import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "16_apperence.svg",
  "use": "16_apperence.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"16_apperence.svg\"><rect width=\"16\" height=\"16\" style=\"fill:none\" /><path d=\"M8.24,7H4.76L4.09,9H3L6,0H7L9.58,7.73l-.83.82ZM7.91,6,6.5,1.8,5.09,6Z\" style=\"fill:#3a3a38\" /><path d=\"M7.13,12.61l7-7c.38-.38,1.72,1,1.35,1.34l-7,7A25.42,25.42,0,0,1,6,15.1,24,24,0,0,1,7.13,12.61Zm6-6,1.31,1.29M7.17,12.59l1.35,1.34\" style=\"fill:#fff;stroke:#228bcb;stroke-miterlimit:1;stroke-width:0.9px\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol